import React, { useEffect, useState } from 'react';
import { HStack } from '@chakra-ui/react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { fullNameUsernameOrEmail } from '../../../helpers/username';
import getStudents from '../helpers/getStudents';
import withNotStudentStatus from '../../app/wrappers/withNotStudentStatus';

interface SelectUserProps {
  studyGroupId: string;
  setStudentId: (value: string | null) => void;
  studentId?: string | null;
}

const SelectUser = (props: SelectUserProps) => {
  const { studyGroupId, studentId, setStudentId } = props;
  const { t } = useTranslation();
  const [students, setStudents] = useState<any[]>([]);
  const studentOptions = React.useMemo(() => {
    return students.map((s) => ({
      value: s.pk,
      label: fullNameUsernameOrEmail(s),
    }));
  }, [students]);

  useEffect(() => {
    getStudents(studyGroupId).then(setStudents);
  }, [studyGroupId]);

  return (
    <HStack spacing={0} justify="space-between">
      <Select
        styles={{
          container: (provided, state) => ({
            ...provided,
            minWidth: '280px',
            maxWidth: '100%',
            textAlign: 'left',
            marginRight: '40% !important',
            marginBottom: '10px',
          }),
        }}
        isClearable
        placeholder={t('selectUser.selectStudent')}
        options={studentOptions}
        value={studentOptions.find((o) => o.value === studentId)}
        onChange={(value) => {
          if (value) setStudentId(value.value);
          else setStudentId(null);
        }}
      />
    </HStack>
  );
};

export default withNotStudentStatus(SelectUser);
